export const ORDERSLIST_REQUEST = "ORDERSLIST_REQUEST";
export const ORDERSLIST_SUCCESS = "ORDERSLIST_SUCCESS";
export const ORDERSLIST_ERROR = "ORDERSLIST_ERROR";
export const ORDERSLIST_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'AppOrdersV1',
    size: 1000,
    filter: []
};